import * as types from './types';

export const updateCurrentUser = (body) => {
	return (api, state) => ({
		type: types.UPDATE_CURRENT_USER,
		payload: api.put('v1/user', { ...body, _id: state.auth._id }),
	})
};
